<template lang="pug">
modal-dialog.modal-login-required(
    role="alertdialog" aria-labelledby="login-signup-required"
    v-bind:show.sync="open"
    v-bind:close-on-esc="true"
    v-on:hide="onClose")

    silhouette-assistant(
        image-name="silhouette-3.svg"
        v-bind:bubble-nr="2")

        div#login-signup-required
            //- anonymous
            span(v-if="membershipLevel < levelBasicUser") {{ $t('signup.signupRequired') }}

            //- logged in but not authorized
            span(v-else-if="membershipLevel < levelRegisteredUser") {{ $t('user.profileFeaturesComing') }}

            //- error?
            span(v-else) {{ $t('common.error') }}

        button.btn(v-on:click="onClose") {{ $t('common.okUnderstood') }}


</template>

<script>
import {
    levelBasicUser,
    levelRegisteredUser
} from '@/store/user';

/* Transparent modal to notify that a clicked action requires an user account. */
export default {
    name: 'modal-login-required',

    props: {
        show: {     type: Boolean, default: false }
    },

    data: function () {
        return {
            open: this.show,
            membershipLevel: 0,
            levelBasicUser,
            levelRegisteredUser
        };
    },

    mounted: function () {
        this.$eventBus.$on('login-required', this.onOpen);

        this.membershipLevel = this.$store.getters['user/getMembershipLevel'];
    },

    beforeDestroy: function () {
        this.$eventBus.$off('login-required', this.onOpen);
    },

    watch: {
        show: function () {
            this.open = this.show;
        }
    },

    methods: {
        onClose: function () {
            this.open = false;
        },

        onOpen: function (error) {
            // TODO: check if error 400, show login
            console.error(error);
            this.open = true;
        }
    }
};
</script>

<style lang="scss">
// @import '~assets/styles/mixins';

.modal-login-required {
    .o-modal__content {
        background: transparent;
        box-shadow: none;
        .character {
            width: 240px;
        }
    }
}
</style>
